import { SettingsActions, TaskCardConfigurationT, SettingsSelectors } from 'pages/settings/settings.controller';
import { connect } from 'react-redux';
import { AppState } from 'redux/store';
import CustomizationConfigurationPopup from 'components/ui-new/customization-configuration-popup/customization-configuration-popup';
import CustomizationTaskCardButton from 'pages/settings/components/customization-task-card-button/customization-task-card-button';
import s from 'pages/settings/settings.module.scss';

type StateProps = {
  isFetchingTaskCardConfiguration: boolean;
  visibleTaskCardConfigurationCount: number;
  taskCardConfiguration: TaskCardConfigurationT[];
};

type DispatchProps = {
  onClickAttribute: (item: TaskCardConfigurationT) => void;
  onDragAttributes: (configurations: TaskCardConfigurationT[]) => void;
};
type Props = StateProps & DispatchProps;

const TaskCardDisplaySettings = ({
  taskCardConfiguration,
  isFetchingTaskCardConfiguration,
  visibleTaskCardConfigurationCount,
  onDragAttributes,
  onClickAttribute,
}: Props) => {
  return (
    <div className={s.row}>
      <div className={s.title_container}>
        <b className={s.row_title}>Task card display settings</b>
        <p className={s.row_description}>Select the fields to be displayed in the task card</p>
      </div>
      <CustomizationConfigurationPopup
        data={taskCardConfiguration}
        count={visibleTaskCardConfigurationCount}
        isLoading={isFetchingTaskCardConfiguration}
        disableDeleteAction={visibleTaskCardConfigurationCount === 1}
        onClickItem={onClickAttribute}
        onDragAttributes={onDragAttributes}
      >
        <CustomizationTaskCardButton count={visibleTaskCardConfigurationCount} />
      </CustomizationConfigurationPopup>
    </div>
  );
};

const mapStateToProps = (state: AppState): StateProps => ({
  taskCardConfiguration: state.settings.taskCardConfiguration,
  isFetchingTaskCardConfiguration: state.settings.isFetchingTaskCardConfiguration,
  visibleTaskCardConfigurationCount: SettingsSelectors.visibleTaskCardAttributesCount(state),
});
const mapDispatchToProps: DispatchProps = {
  onDragAttributes: SettingsActions.onDragAttributes,
  onClickAttribute: SettingsActions.onClickAttribute,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskCardDisplaySettings);
